// import React, { useEffect, useState } from "react";
// import SettingIcon from '../../../src/assets/images/svg/header/icon_sidebar_inactive_setting.svg'
// import NotificationIcon from '../../../src/assets/images/svg/header/bell-svgrepo-com.svg'
// import ProfileIcon from '../../../src/assets/images/svg/header/profile-1341-svgrepo-com.svg'
// import DownBlackIcon from '../../../src/assets/images/svg/header/down-arrow-backup-2-svgrepo-com.svg'
// import DownWhiteIcon from '../../../src/assets/images/svg/header/down-arrow-backup-white-2-svgrepo-com.svg'
// import HamburgerIcon from '../../../src/assets/images/svg/header/icon_navbar_hamberger.svg'
// import { useLocation, useNavigate } from "react-router-dom";
// import { LazyLoadImage } from "react-lazy-load-image-component";
// import SevanestLogo from '../../../src/assets/images/png/sevanest-resize-logo-1.png'

// const Header = ({ navigation }) => {

//   // ----------------------  navigation & location keys --------------------------
//   const navigate = useNavigate();
//   const location = useLocation();

//   // ----------------------  state for active menu, menu options, menu open, sidebar open --------------------------
//   const [isActive, setIsActive] = useState('')
//   const [isMenuOption, setIsMenuOption] = useState('')
//   const [isMenuOpen, setIsMenuOpen] = useState(false)
//   const [isSidebarOpen, setIsSidebarOpen] = useState(false)

//   // ----------------------  useEffect to set active menu based on location path --------------------------
//   useEffect(() => {
//     const activeItem = navigation?.superItems.find(item => location.pathname.includes(item.url));
//     if (activeItem) {
//       setIsActive(activeItem.title);
//     }
//   }, [location.pathname]);

//   const handleActive = (value) => {
//     setIsActive(value)
//   }

//   // ----------------------  Handle Menu Option and Menu Open --------------------------
//   const handleMenuOption = (value) => {
//     if (isMenuOption != value) {
//       setIsMenuOption(value)
//     } else {
//       setIsMenuOption('')
//     }

//   }

//   // ----------------------  Handle Menu Open for See More --------------------------
//   const handleMenuOpen = (id) => {
//     if (id === 'SeeMore') {
//       setIsMenuOpen(!isMenuOpen)
//     } else {
//       setIsMenuOpen(false)
//     }
//   }
//   let SeeMoreData = navigation?.superItems?.filter((val) => val.id == 'SeeMore')

//   // ----------------------  Handle Sidebar Open --------------------------
//   const handleSidebar = () => {
//     setIsSidebarOpen(!isSidebarOpen)
//   }

//   // ----------------------  Navigate to URL --------------------------
//   const goToUrl = (url) => {
//     if (url) {
//       navigate(url);
//     }
//   };

//   return (

//     <div className="main-header">
//       <div className="main-logo">
//         <LazyLoadImage src={SevanestLogo} />
//       </div>
//       <div className="main-navigation">
//         <div className="custom-menu">
//           <ul className="navigation-menu menu">
//             {navigation?.superItems.map((val, index) => {
//               return (
//                 <li className={`menu-items ${isActive === val.title ? 'active-menu-items' : ''}`} onClick={() => handleActive(val.title)} key={index} >
//                   <div className="d-flex align-items-center gap-1" onClick={() => {
//                     handleMenuOption(val.isChildren ? val.title : '');
//                     handleMenuOpen(val.id);
//                     goToUrl(val.url);
//                   }}>
//                     {val.title}
//                     {
//                       val.isChildren === true
//                         ?
//                         isActive === val.title ?
//                           <img src={DownWhiteIcon} alt="" />
//                           :
//                           <img src={DownBlackIcon} alt="" />
//                         :
//                         ''
//                     }
//                   </div>
//                   {(isMenuOption === val.title && val.id != 'SeeMore') &&
//                     <ul className={isMenuOption === val.title ? 'menu-options' : ''}>
//                       {val?.children?.map((child, childIndex) => (
//                         <li
//                           className="menu-items-options"
//                           key={childIndex}
//                           onClick={(e) => {
//                             e.stopPropagation(); // Taaki parent ka click trigger na ho
//                             goToUrl(child.url);
//                             setIsMenuOption(''); // Dropdown band ho jaye click ke baad
//                           }}
//                         >
//                           {child?.title}
//                         </li>
//                       ))}
//                     </ul>
//                   }
//                 </li>
//               )
//             })}
//           </ul>
//           {/* <div>
//           </div> */}
//         </div>
//         <div className="navigation-menu curs">
//           <div className="menu-items settings">
//             <div>
//               <img src={SettingIcon} alt="" />
//             </div>
//             <span>Settings</span>
//           </div>
//         </div>
//         <div className="navigation-menu icon-padding">
//           <div className="menu-items">
//             <img src={NotificationIcon} alt="" />
//           </div>
//         </div>
//         <div className="navigation-menu icon-padding">
//           <div className="menu-items">
//             <img src={ProfileIcon} alt="" />
//           </div>
//         </div>
//       </div>
//       <div className="main-navigation-sidebar">
//         <div className="hamburger-icon custom-cursor-pointor" onClick={() => handleSidebar()}>
//           <img src={HamburgerIcon} alt="" />
//         </div>
//         <div className={`sidebar-navigation-drawer ${isSidebarOpen === true ? 'sidebar-open' : ''}`}>
//           {navigation?.frItems?.map((val, index) => {
//             return (
//               <li className="drawer-menu-item" key={index}>
//                 <div className="d-flex align-items-center justify-content-between gap-1" onClick={() => handleMenuOption(val.isChildren ? val.title : '')}>
//                   {val?.title}
//                   {
//                     val.isChildren === true
//                       ?
//                       <img src={DownBlackIcon} alt="" />
//                       :
//                       ''
//                   }
//                 </div>
//                 {
//                   val.isChildren === true &&
//                   <ul className={`drawer-menu-options ${isMenuOption === val.title ? 'active-drawer-menu-options' : ''}`}>
//                     {val?.children?.map((child, index) => {
//                       return (
//                         <li className="custom-sub-child" key={index}>
//                           {child.title}
//                         </li>
//                       )
//                     })}
//                   </ul>
//                 }
//               </li>
//             )
//           })}
//         </div>
//       </div>
//       <ul className={`header-navigation-drawer ${isMenuOpen === true ? " header-navigation-drawer-show " : ""}`}>
//         {SeeMoreData[0]?.children?.map((val, index) => {
//           return (
//             <li className="drawer-menu-item" key={index} onClick={() => goToUrl(val.url)} >
//               <div className="d-flex align-items-center justify-content-between gap-1" onClick={() => handleMenuOption(val.isSubChildren ? val.title : '')}>
//                 {val?.title}
//                 {
//                   val.isSubChildren === true
//                     ?
//                     <img src={DownBlackIcon} alt="" />
//                     :
//                     ''
//                 }
//               </div>
//               {
//                 val.isSubChildren === true &&
//                 <ul className={`drawer-menu-options ${isMenuOption === val.title ? 'active-drawer-menu-options' : ''}`}>
//                   {val?.subChildren?.map((child, index) => {
//                     return (
//                       <li className="custom-sub-child" key={index}>
//                         {child.title}
//                       </li>
//                     )
//                   })}
//                 </ul>
//               }
//             </li>
//           )
//         })}
//       </ul>
//     </div>
//   )
// }

// export default Header

// /////////////////////////////////////  FINAL HEADER /////////////////////////////////
// import React, { useEffect, useState } from "react";
// import SettingIcon from "../../../src/assets/images/svg/header/icon_sidebar_inactive_setting.svg";
// import NotificationIcon from "../../../src/assets/images/svg/header/bell-svgrepo-com.svg";
// import ProfileIcon from "../../../src/assets/images/svg/header/profile-1341-svgrepo-com.svg";
// import DownBlackIcon from "../../../src/assets/images/svg/header/down-arrow-backup-2-svgrepo-com.svg";
// import DownWhiteIcon from "../../../src/assets/images/svg/header/down-arrow-backup-white-2-svgrepo-com.svg";
// import HamburgerIcon from "../../../src/assets/images/svg/header/icon_navbar_hamberger.svg";
// import { useLocation, useNavigate } from "react-router-dom";
// import { LazyLoadImage } from "react-lazy-load-image-component";
// import SevanestLogo from "../../../src/assets/images/png/sevanest-resize-logo-1.png";

// const Header = ({ navigation }) => {
//   const navigate = useNavigate();
//   const location = useLocation();

//   const [activeMenu, setActiveMenu] = useState("");
//   const [openDropdown, setOpenDropdown] = useState("");
//   const [seeMoreOpen, setSeeMoreOpen] = useState(false);
//   const [sidebarOpen, setSidebarOpen] = useState(false);

//   // ✅ Active menu auto detect from route
//   useEffect(() => {
//     const activeItem = navigation?.superItems?.find((item) =>
//       location.pathname.includes(item.url)
//     );
//     if (activeItem) {
//       setActiveMenu(activeItem.title);
//     }
//   }, [location.pathname, navigation]);

//   // ✅ Menu click handler
//   const handleMenuClick = (item) => {
//     setActiveMenu(item.title);

//     if (item.isChildren) {
//       setOpenDropdown(openDropdown === item.title ? "" : item.title);
//     } else {
//       setOpenDropdown("");
//       if (item.url) navigate(item.url);
//     }

//     if (item.id === "SeeMore") {
//       setSeeMoreOpen(!seeMoreOpen);
//     } else {
//       setSeeMoreOpen(false);
//     }
//   };

//   const goToUrl = (url) => {
//     if (url) navigate(url);
//   };

//   const seeMoreData = navigation?.superItems?.find((x) => x.id === "SeeMore");

//   return (
//     <div className="main-header">
//       {/* LOGO */}
//       <div className="main-logo">
//         <LazyLoadImage src={SevanestLogo} alt="logo" />
//       </div>

//       {/* MAIN NAVIGATION */}
//       <div className="main-navigation">
//         <div className="custom-menu">
//           <ul className="navigation-menu menu">
//             {navigation?.superItems?.map((item, index) => (
//               <li
//                 key={index}
//                 className={`menu-items ${activeMenu === item.title ? "active-menu-items" : ""
//                   }`}
//                 onClick={() => handleMenuClick(item)}
//               >
//                 <div className="d-flex align-items-center gap-1">
//                   {item.title}
//                   {item.isChildren && (
//                     <img
//                       src={
//                         activeMenu === item.title
//                           ? DownWhiteIcon
//                           : DownBlackIcon
//                       }
//                       alt=""
//                     />
//                   )}
//                 </div>

//                 {/* DROPDOWN */}
//                 {openDropdown === item.title && item.id !== "SeeMore" && (
//                   <ul className="menu-options">
//                     {item?.children?.map((child, i) => (
//                       <li
//                         key={i}
//                         className="menu-items-options"
//                         onClick={(e) => {
//                           e.stopPropagation();
//                           goToUrl(child.url);
//                           setOpenDropdown("");
//                         }}
//                       >
//                         {child.title}
//                       </li>
//                     ))}
//                   </ul>
//                 )}
//               </li>
//             ))}
//           </ul>
//         </div>

//         {/* RIGHT ICONS */}
//         <div className="navigation-menu curs">
//           <div className="menu-items settings">
//             <img src={SettingIcon} alt="" />
//             <span>Settings</span>
//           </div>
//         </div>

//         <div className="navigation-menu icon-padding">
//           <div className="menu-items">
//             <img src={NotificationIcon} alt="" />
//           </div>
//         </div>

//         <div className="navigation-menu icon-padding">
//           <div className="menu-items">
//             <img src={ProfileIcon} alt="" />
//           </div>
//         </div>
//       </div>

//       {/* SIDEBAR (MOBILE) */}
//       <div className="main-navigation-sidebar">
//         <div
//           className="hamburger-icon custom-cursor-pointor"
//           onClick={() => setSidebarOpen(!sidebarOpen)}
//         >
//           <img src={HamburgerIcon} alt="" />
//         </div>

//         <div
//           className={`sidebar-navigation-drawer ${sidebarOpen ? "sidebar-open" : ""
//             }`}
//         >
//           {navigation?.frItems?.map((item, index) => (
//             <li key={index} className="drawer-menu-item">
//               <div
//                 className="d-flex align-items-center justify-content-between gap-1"
//                 onClick={() =>
//                   setOpenDropdown(openDropdown === item.title ? "" : item.title)
//                 }
//               >
//                 {item.title}
//                 {item.isChildren && <img src={DownBlackIcon} alt="" />}
//               </div>

//               {item.isChildren && (
//                 <ul
//                   className={`drawer-menu-options ${openDropdown === item.title
//                       ? "active-drawer-menu-options"
//                       : ""
//                     }`}
//                 >
//                   {item?.children?.map((child, i) => (
//                     <li
//                       key={i}
//                       className="custom-sub-child"
//                       onClick={() => goToUrl(child.url)}
//                     >
//                       {child.title}
//                     </li>
//                   ))}
//                 </ul>
//               )}
//             </li>
//           ))}
//         </div>
//       </div>

//       {/* SEE MORE MENU */}
//       {seeMoreOpen && (
//         <ul className="header-navigation-drawer header-navigation-drawer-show">
//           {seeMoreData?.children?.map((item, index) => (
//             <li
//               key={index}
//               className="drawer-menu-item"
//               onClick={() => goToUrl(item.url)}
//             >
//               <div className="d-flex align-items-center justify-content-between gap-1">
//                 {item.title}
//                 {item.isSubChildren && (
//                     <img
//                       src={
//                         activeMenu === item.title
//                           ? DownBlackIcon
//                           : DownWhiteIcon
//                       }
//                       alt=""
//                     />
//                   )}
//               </div>
//             </li>
//           ))}
//         </ul>
//       )}
//     </div>
//   );
// };

// export default Header;



import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { LazyLoadImage } from "react-lazy-load-image-component";
import SettingIcon from "../../../src/assets/images/svg/header/icon_sidebar_inactive_setting.svg";
import NotificationIcon from "../../../src/assets/images/svg/header/bell-svgrepo-com.svg";
import ProfileIcon from "../../../src/assets/images/svg/header/profile-1341-svgrepo-com.svg";
import EditIcon from "../../../src/assets/images/svg/header/icon_edit_profile.svg";
import LogoutIcon from "../../../src/assets/images/svg/header/icon_logout.svg";
import DownBlackIcon from "../../../src/assets/images/svg/header/down-arrow-backup-2-svgrepo-com.svg";
import DownWhiteIcon from "../../../src/assets/images/svg/header/down-arrow-backup-white-2-svgrepo-com.svg";
import HamburgerIcon from "../../../src/assets/images/svg/header/icon_navbar_hamberger.svg";
import HamburgerCloseIcon from "../../../src/assets/images/svg/header/icon_navbar_hamberger_close.svg";
import SevanestLogo from "../../../src/assets/images/png/sevanest-resize-logo-1.png";
import { Button, NavDropdown } from "react-bootstrap";
import { useDispatch } from "react-redux";
import * as actionType from "../../../src/ReduxManager/actions";
import { connectSocket, disconnectSocket } from "../../Utils/socket";
import { useSelector } from "react-redux";
import { ORDER_STATUS_UPDATE } from "../../ReduxManager/actions";

const Header = ({ navigation }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const { isAuthorised, userId } = useSelector((state) => state);
  const [activeMenu, setActiveMenu] = useState("");
  const [openDropdown, setOpenDropdown] = useState("");
  // const [openSubDropdown, setOpenSubDropdown] = useState("");
  const [seeMoreOpen, setSeeMoreOpen] = useState(false);
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [openModule, setOpenModule] = useState("");

  /* ---------------- ACTIVE MENU AUTO ---------------- */
  useEffect(() => {
    const activeItem = navigation?.superItems?.find(
      (item) => item.url && location.pathname.includes(item.url),
    );
    if (activeItem) setActiveMenu(activeItem.title);
  }, [location.pathname, navigation]);

  /* ---------------- HANDLERS ---------------- */
  const goToUrl = (url) => {
    if (url) navigate(url);
  };

  const handleMenuClick = (item) => {
    setActiveMenu(item.title);

    if (item.id === "SeeMore") {
      setSeeMoreOpen(!seeMoreOpen);
      setOpenDropdown("");
      return;
    }

    if (item.isChildren) {
      setOpenDropdown(openDropdown === item.title ? "" : item.title);
    } else {
      setOpenDropdown("");
      setSeeMoreOpen(false);
      goToUrl(item.url);
    }
  };

  const seeMoreData = navigation?.superItems?.find(
    (item) => item.id === "SeeMore",
  );

  const handleMobileNavigate = (url) => {
    if (url) {
      navigate(url);
      setSidebarOpen(false);
      setOpenModule("");
    }
  };

  /* ---------------- SAVE ACTIVE MODULE ---------------- */
  const isParentActive = (item) => {
    if (item.url && location.pathname.includes(item.url)) return true;

    if (item.children) {
      return item.children.some((child) =>
        location.pathname.includes(child.url),
      );
    }

    return false;
  };

  const getActiveModuleFromRoute = () => {
    const items = navigation?.superItems?.flatMap((item) =>
      item.id === "SeeMore" ? item.children : item,
    );

    for (let item of items) {
      if (item.children) {
        const match = item.children.find((child) =>
          location.pathname.includes(child.url),
        );

        if (match) return item.id;
      }
    }

    return "";
  };

  useEffect(() => {
    const activeModule = getActiveModuleFromRoute();
    setOpenModule(activeModule);
  }, [location.pathname, navigation]);

  useEffect(() => {
    if (!isAuthorised || !userId) return;

    const socket = connectSocket("admin", userId);

    const handleNotification = (data) => {
      console.log("📦 RAW:", data);

      if (data?.type === "ORDER_STATUS_UPDATE") {
        console.log("🔥 ORDER STATUS UPDATE:", data);
        dispatch({
          type: ORDER_STATUS_UPDATE,
          payload: data,
        });
      }
    };

    // Pehle remove karo agar pehle se laga ho
    socket.off("notification", handleNotification);

    // Fir attach karo
    socket.on("notification", handleNotification);

    return () => {
      socket.off("notification", handleNotification);
    };
  }, [isAuthorised, userId]);

  /* ---------------- Admin Log Out ---------------- */
  const handleLogout = () => {
    disconnectSocket();
    dispatch({ type: actionType.CLEAR_REDUX_STATE });
  };


  /* ---------------- JSX ---------------- */
  return (
    <div className="main-header">
      {/* LOGO */}
      <div className="main-logo">
        {/* <LazyLoadImage src={SevanestLogo} alt="logo" /> */}
        TASK : 1
      </div>

      {/* MAIN NAV */}
      <div className="main-navigation">
        <div className="custom-menu">
          <ul className="navigation-menu menu">
            {navigation?.superItems?.map((item, index) => (
              <li
                key={index}
                className={`menu-items ${activeMenu === item.title ? "active-menu-items" : ""
                  }`}
                onClick={() => handleMenuClick(item)}
              >
                <div className="d-flex align-items-center gap-1">
                  {item.title}
                  {item.isChildren && (
                    <img
                      src={
                        activeMenu === item.title
                          ? DownWhiteIcon
                          : DownBlackIcon
                      }
                      alt=""
                    />
                  )}
                </div>

                {/* FIRST LEVEL DROPDOWN */}
                {openDropdown === item.title && item.id !== "SeeMore" && (
                  <ul className="menu-options">
                    {item?.children?.map((child, i) => (
                      <li
                        key={i}
                        className="menu-items-options"
                        onClick={(e) => {
                          e.stopPropagation();
                          goToUrl(child.url);
                          setOpenDropdown("");
                        }}
                      >
                        {child.title}
                      </li>
                    ))}
                  </ul>
                )}
              </li>
            ))}
          </ul>
        </div>

        {/* RIGHT ICONS */}
        {/* <div className="navigation-menu curs">
          <div className="menu-items settings">
            <img src={SettingIcon} alt="" />
            <span>Settings</span>
          </div>
        </div> */}

        <div className="navigation-menu icon-padding">
          <div className="menu-items">
            <img src={NotificationIcon} alt="" />
          </div>
        </div>

        <div className="navigation-menu icon-padding">
          <div className="menu-items d-flex profile">
            <img src={ProfileIcon} alt="" className="me-2" />
            <NavDropdown
              id="nav-dropdown-dark-example"
              title="salman"
            // menuVariant="dark"
            >
              <NavDropdown.Item href="#action/3.1">
                <div className="d-flex align-items-center">
                  <img src={ProfileIcon} alt="" className="me-2" />
                  <div className="">
                    <p className="mb-0">salman</p>
                    <span>salman@sevanest.com</span>
                  </div>
                </div>
              </NavDropdown.Item>
              <NavDropdown.Item href="#action/3.2">
                <div className="d-flex align-items-center">
                  <img src={EditIcon} alt="" className="me-2" />
                  <div className="">
                    <p className="mb-0">Edit Profile</p>
                  </div>
                </div>
              </NavDropdown.Item>
              <NavDropdown.Item as={Button} onClick={handleLogout}>
                <div className="d-flex align-items-center">
                  <img src={LogoutIcon} alt="" className="me-2" />
                  <div className="">
                    <p className="mb-0">Logout</p>
                  </div>
                </div>
              </NavDropdown.Item>
              {/* <NavDropdown.Divider />
              <NavDropdown.Item href="#action/3.4">
                Separated link
              </NavDropdown.Item> */}
            </NavDropdown>
          </div>
        </div>
      </div>

      {/* MOBILE SIDEBAR */}
      <div className="main-navigation-sidebar">
        <div
          className="hamburger-icon"
          onClick={() => setSidebarOpen(!sidebarOpen)}
        >
          {sidebarOpen ? (
            <img src={HamburgerCloseIcon} alt="" />
          ) : (
            <img src={HamburgerIcon} alt="" />
          )}
        </div>

        {/* ===== MOBILE DRAWER ===== */}
        <div
          className={`mobile-sidebar-overlay ${sidebarOpen ? "show" : ""}`}
          onClick={() => setSidebarOpen(false)}
        ></div>

        <div className={`mobile-sidebar ${sidebarOpen ? "open" : ""}`}>
          {/* LOGO */}
          <div className="mobile-sidebar-header">
            {/* <img src={SevanestLogo} alt="logo" /> */}
            <div className="main-logo">
              {/* <LazyLoadImage src={SevanestLogo} alt="logo" /> */}
              TASK : 1
            </div>
          </div>

          {/* MENU LIST */}
          <ul className="mobile-sidebar-menu p-0">
            {navigation?.superItems
              ?.flatMap((item) =>
                item.id === "SeeMore" ? item.children : item,
              )
              ?.map((item, index) => {
                const isOpen = openModule === item.id;
                const parentActive = isParentActive(item);

                return (
                  <li
                    className={`mobile-menu-list ${
                      // parentActive || isOpen ? "active-mobile-menu-list" : ""
                      parentActive || isOpen ? "active-mobile-menu-list" : ""
                      }`}
                    key={index}
                  >
                    <div
                      className={`mobile-menu-item ${parentActive || isOpen ? "active-mobile-item" : ""
                        }`}
                      onClick={() =>
                        item.isChildren
                          ? setOpenModule(isOpen ? "" : item.id)
                          : handleMobileNavigate(item.url)
                      }
                    >
                      <div className="mobile-menu-item-left">
                        {item.isIcon && (
                          <img
                            src={
                              parentActive || isOpen
                                ? item.active_icon
                                : item.inactive_icon
                            }
                            alt="sidebar icon"
                            className="mobile-menu-module-icon"
                          />
                        )}
                        <span className="mobile-menu-title">{item.title}</span>
                      </div>

                      {item.isChildren && (
                        <span
                          //  className={`arrow ${isOpen ? "arrow-open" : ""}`}
                          className={`mobile-menu-drwwer-icon ${parentActive || isOpen
                            ? "active-mobile-menu-drwwer-icon"
                            : ""
                            }`}
                        >
                          {isOpen ? (
                            <i className="pi pi-angle-up"></i>
                          ) : (
                            <i className="pi pi-angle-down"></i>
                          )}
                        </span>
                      )}
                    </div>

                    {/* CHILDREN */}
                    {item.isChildren && (
                      <ul className={`mobile-submenu ${isOpen ? "show" : ""}`}>
                        {item.children?.map((child, i) => (
                          <li
                            key={i}
                            className={`mobile-sub-child ${location.pathname.includes(child.url)
                              ? "active-mobile-sub-child"
                              : ""
                              }`}
                            onClick={() => handleMobileNavigate(child.url)}
                          >
                            • {child.title}
                          </li>
                        ))}
                      </ul>
                    )}
                  </li>
                );
              })}
          </ul>
        </div>
      </div>

      {/* ================= SEE MORE DRAWER ================= */}
      {/* {seeMoreOpen && (
        <ul className="header-navigation-drawer header-navigation-drawer-show">
          {seeMoreData?.children?.map((item, index) => (
            <li key={index} className="drawer-menu-item">
              <div
                className="d-flex align-items-center justify-content-between gap-1 p-3"
                onClick={(e) => {
                  e.stopPropagation();
                  if (item.isChildren) {
                    setOpenSubDropdown(
                      openSubDropdown === item.title ? "" : item.title,
                    );
                  } else {
                    goToUrl(item.url);
                    setSeeMoreOpen(false);
                  }
                }}
              >
                {item.title}
                {item.isChildren && <img src={DownWhiteIcon} alt="" />}
              </div> */}

      {/* 🔥 INFO CHILDREN */}
      {/* {item.isChildren && openSubDropdown === item.title && (
                <ul className="drawer-menu-options active-drawer-menu-options">
                  {item.children?.map((child, i) => (
                    <li
                      key={i}
                      className="custom-sub-child"
                      onClick={(e) => {
                        e.stopPropagation();
                        goToUrl(child.url);
                        setOpenSubDropdown("");
                        setSeeMoreOpen(false);
                      }}
                    >
                      {child.title}
                    </li>
                  ))}
                </ul>
              )}
            </li>
          ))}
        </ul>
      )} */}

      {seeMoreOpen && (
        <>
          {/* OVERLAY */}
          <div
            className="see-more-overlay"
            onClick={() => setSeeMoreOpen(false)}
          ></div>

          {/* DROPDOWN */}
          <ul className="header-navigation-drawer header-navigation-drawer-show">
            {seeMoreData.children.map((item, index) => {
              const isOpen = openModule === item.id;
              const parentActive = isParentActive(item);

              return (
                <li
                  className={`mobile-menu-list ${parentActive || isOpen ? "active-mobile-menu-list" : ""
                    }`}
                  key={index}
                >
                  <div
                    className={`mobile-menu-item ${parentActive || isOpen ? "active-mobile-item" : ""
                      }`}
                    onClick={() =>
                      item.isChildren
                        ? setOpenModule(isOpen ? "" : item.id)
                        : handleMobileNavigate(item.url)
                    }
                  >
                    <div className="mobile-menu-item-left">
                      {item.isIcon && (
                        <img
                          src={
                            parentActive || isOpen
                              ? item.active_icon
                              : item.inactive_icon
                          }
                          alt="sidebar icon"
                          className="mobile-menu-module-icon"
                        />
                      )}
                      <span className="mobile-menu-title">{item.title}</span>
                    </div>

                    {item.isChildren && (
                      <span
                        className={`mobile-menu-drwwer-icon ${parentActive || isOpen
                          ? "active-mobile-menu-drwwer-icon"
                          : ""
                          }`}
                      >
                        {isOpen ? (
                          <i className="pi pi-angle-up"></i>
                        ) : (
                          <i className="pi pi-angle-down"></i>
                        )}
                      </span>
                    )}
                  </div>

                  {/* CHILDREN */}
                  {item.isChildren && (
                    <ul className={`mobile-submenu ${isOpen ? "show" : ""}`}>
                      {item.children?.map((child, i) => (
                        <li
                          key={i}
                          className={`mobile-sub-child ${location.pathname.includes(child.url)
                            ? "active-mobile-sub-child"
                            : ""
                            }`}
                          onClick={() => handleMobileNavigate(child.url)}
                        >
                          • {child.title}
                        </li>
                      ))}
                    </ul>
                  )}
                </li>
              );
            })}
          </ul>
        </>
      )}
    </div>
  );
};

export default Header;
